import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from 'AppRoutes';
import { Layout } from 'Layouts/Layout';
import { NewsProvider } from 'Components/NewsContext';
import Loading from 'Components/Loading';

const App = () => {
    return (
        <NewsProvider>
            <Layout>
                <Suspense fallback={<Loading />}>
                    <Routes>
                        {AppRoutes.map((route, index) => {
                            const { element, ...rest } = route;
                            return <Route key={index} {...rest} element={element} />;
                        })}
                    </Routes>
                </Suspense>
            </Layout>
        </NewsProvider>
    );
};

export default App;
